import React, { useEffect, useState } from 'react'
import { baseUrl, removePopup } from '../../../../../utils';
import ModalData from "./ModalContent";
import ReactHtmlParser from 'react-html-parser';
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';
import { togglePublishSection } from '../../../../../actions/show_modal_Action';
import { useDispatch } from 'react-redux';
import { getWidgetWallData } from '../../../../../actions/wallDataAction';
import { LIVE_API } from '../../../../../actions/api';
import { useCookies } from 'react-cookie';
import { Button } from 'react-bootstrap';

const PublishModels = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [previewKey, setpreviewKey] = useState(0);
    const { wallId } = props.wallData;
    const [cookies, setCookie] = useCookies(['__webpage', '__emailCampaign']);

    window.$(document).on('hide.bs.modal', function () {
        pauseVideo()
    })

    $(document).on('click', '.explore-card', function () {
        setpreviewKey(Math.floor(Math.random() * 10));
    })

    const pauseVideo = () => {
        $('#TagBasedVideo').prop('src', 'https://player.vimeo.com/video/764430821?autoplay=0');
        $('#emailCampaignVideo').prop('src', 'https://player.vimeo.com/video/771433320?autoplay=0');
        $('#runSocialAds').prop('src', 'https://player.vimeo.com/video/771434260?autoplay=0');
    }

    setTimeout(() => {

        var tagWidgetModal = $('#tagWidgetModal').hasClass('show');
        var emailCampaignModal = $('#emailCampaignModal').hasClass('show');
        var socailAdsModal = $('#socailAdsModal').hasClass('show');

        if (tagWidgetModal) {
            $('#TagBasedVideo').prop('src', 'https://player.vimeo.com/video/764430821?autoplay=1');
        }

        if (emailCampaignModal) {
            $('#emailCampaignVideo').prop('src', 'https://player.vimeo.com/video/771433320?autoplay=1');
        }

        if (socailAdsModal) {
            $('#runSocialAds').prop('src', 'https://player.vimeo.com/video/771434260?autoplay=1');
        }

    }, 180);


    const getPage = (id) => {

        const { wallId, wallOwner } = props.wallData;

        if (id == 2) {
            navigate(`/moderation/index/${wallId}`)
        } else {

            if (id == 3) {
                setCookie('__emailCampaign', true)
            } else {
                setCookie('__webpage', true)
            }

            dispatch(togglePublishSection(true));

            dispatch(getWidgetWallData(wallOwner, wallId))
            setTimeout(() => {
                navigate(`/widget/wall/index/${wallId}`)
            }, 1000);
        }
    }


    useEffect(() => {
        pauseVideo()
    }, []);


    return (
        <>
            {ModalData[1].map((curr, index) => {

                const { type, redirect, link_type, id, btnName, name, labelledby, iframeID, modelId, text, videoURL, btnURL } = curr;

                return (
                    <div className="modal fade" id={modelId} tabindex="-1" aria-labelledby={labelledby} aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-width modal-lg">
                            <div className="modal-content">
                                <div className="modal-header border-0 pb-0">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="text-center">


                                        {type == 'image' ? <div className="Errorimage pb-3">
                                            <img src={`${videoURL}`} />
                                        </div> :

                                            (type == 'video' ? <div className="Errorimage pb-3">


                                                <video className={`img-fluid ${name == 'Shoppable Galleries' ? 'shoppableGalleries' : null} `} autoPlay id="audioTag" loop playsinline muted>
                                                    <source src={baseUrl(`products/${videoURL}?autoplay=1&muted=1`)} type="video/mp4" />
                                                </video>
                                            </div>
                                                :
                                                <div className="vimeo_video_wrap mb-3 bg-light">
                                                    <iframe id={iframeID} src={`https://player.vimeo.com/video/${videoURL}`} width="100%" height="410" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Tag-based Widget"></iframe>

                                                </div>
                                            )}


                                        <div className="permissionMsg mty-4 px-4">
                                            <h4 className="ErrorMsg">{name}</h4>
                                            <p className="msgSec">{ReactHtmlParser(text)}</p>
                                        </div>
                                        <div className="buttonUpgred mb-3">
                                            {
                                                link_type == 1 ?
                                                    <a target={redirect == 'new-tab' ? '_blank' : '_parent'} href={btnName === "Try Taggshop" ? `https://${LIVE_API ? 'app' : 'test'}.taggshop.io/autologin?token=${localStorage.getItem('sessionToken')}&callback=https://${LIVE_API ? 'app' : 'test'}.taggshop.io/v2/redirectlogin/${localStorage.getItem('loginToken')}` : btnURL} className="btn btn-primary btn-min-w">{btnName}</a>
                                                    :
                                                    <Button variant='primary' onClick={() => { removePopup(); getPage(id) }} to={`${btnURL}${wallId}`} className="px-5">{btnName} </Button>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}


        </>
    )
}

export default PublishModels